import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import QueuesList from 'pages/SipConfiguration/Queues';
import SipTrunks from 'pages/SipConfiguration/TrunkFlows';
import React, { ChangeEvent, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TabPanel } from '~components/TabPanel';
import PredictiveAgentStatuses from '~pages/SipConfiguration/AgentStatuses';
import ContactFlows from '~pages/SipConfiguration/ContactFlows';
import IVRMessageList from '~pages/SipConfiguration/IVRMessageList';
import { useSetPageTitleProps } from '~providers/PageTitleProvider';

// Used to manage visible tab selection
enum ViewTabsType {
  AgentStates,
  IVRMessages,
  Queues,
  TrunkFlows,
  ContactFlows,
}

// default tab, fallback to this tab when no permission on specified tab
const defaultViewTab = ViewTabsType.AgentStates;

const a11yProps = (index: number) => ({
  'id': `tab-${index}`,
  'aria-controls': `tab-${index}`,
});

export const SipConfiguration = () => {
  const setPageTitleProps = useSetPageTitleProps();
  const [searchParams, setSearchParams] = useSearchParams({
    show: ViewTabsType[defaultViewTab],
  });
  const showParam = searchParams.get('show');
  const tabIndex = showParam ? +ViewTabsType[showParam as any] : defaultViewTab;

  // Set page title
  useEffect(() => {
    setPageTitleProps({ pageName: 'SIP Configuration' });
  }, []);

  const onTabChange = (e: ChangeEvent<{}>, tabIndex: number): void => {
    setSearchParams({
      show: ViewTabsType[tabIndex],
    });
  };

  return (
    <>
      <Typography variant='h4' component='h1' gutterBottom>
        SIP Configuration
      </Typography>

      <Tabs
        orientation='horizontal'
        variant='scrollable'
        onChange={onTabChange}
        value={tabIndex}
        indicatorColor='primary'
        aria-label='Vertical tabs example'>
        <Tab label='Agent States' {...a11yProps(ViewTabsType.AgentStates)} value={ViewTabsType.AgentStates} />
        <Tab label='IVR Messages' {...a11yProps(ViewTabsType.IVRMessages)} value={ViewTabsType.IVRMessages} />
        <Tab label='Queues' {...a11yProps(ViewTabsType.Queues)} value={ViewTabsType.Queues} />
        <Tab label='Trunk Flows' {...a11yProps(ViewTabsType.TrunkFlows)} value={ViewTabsType.TrunkFlows} />
        <Tab label='Contact Flows' {...a11yProps(ViewTabsType.ContactFlows)} value={ViewTabsType.ContactFlows} />
      </Tabs>

      <Divider variant='fullWidth' component='hr' />

      <TabPanel value={tabIndex} index={ViewTabsType.AgentStates}>
        <PredictiveAgentStatuses />
      </TabPanel>

      <TabPanel value={tabIndex} index={ViewTabsType.IVRMessages}>
        <IVRMessageList />
      </TabPanel>

      <TabPanel value={tabIndex} index={ViewTabsType.Queues}>
        <QueuesList />
      </TabPanel>

      <TabPanel value={tabIndex} index={ViewTabsType.TrunkFlows}>
        <SipTrunks />
      </TabPanel>

      <TabPanel value={tabIndex} index={ViewTabsType.ContactFlows}>
        <ContactFlows />
      </TabPanel>
    </>
  );
};

export default SipConfiguration;
